<div class="container">
    <div class="count-img">
        {{ activeIndex + 1 }}/{{ images.length }}
    </div>
    <div class="full-screen" (click)="openPreviewFullScreen()" *ngIf="!(isMobile$ | async)">
        <img src="assets/images/new-design-icons/Full-Screen (white).svg"/>
    </div>
    <p-galleria
       #galleria
       [class]="gClass"
       [(activeIndex)]="activeIndex"
       [value]="images"
       [showThumbnails]="!(isMobile$ | async)"
       [showItemNavigators]="true"
       [showItemNavigatorsOnHover]="true"
       [responsiveOptions]="responsiveOptions"
       [circular]="true"
       [numVisible]="5"
       [containerStyle]="{ 'max-width': '100%'}">
        <ng-template pTemplate="item" let-item>
            <ng-container *ngIf="isVideo(item); else imgTmp">
                <div [style.width]="'100%'" (swipeleft)="nextImage()" (swiperight)="prevImage()">
                    <app-video-review [width]="'100%'" [borderRadius]="'12px'" [height]="(isMobile$ | async) ? '480px' : (fullscreen ? '100vh' : '500px')" [videoInfo]="getVideoInfo(item)"></app-video-review>
                </div>
            </ng-container>

            <ng-template #imgTmp>
                <img [src]="url(item)"
                 (swipeleft)="nextImage()" (swiperight)="prevImage()"
                 [ngStyle]="{
                    width: !fullscreen ? 'auto' : '', display: !fullscreen ? 'block' : '',
                    height: (isMobile$ | async) ? '480px' : fullscreen ? '100vh' : 'auto',
                    'max-height': '482px',
                 }" loading="lazy" />
            </ng-template>
        </ng-template>
        <ng-template pTemplate="thumbnail" let-item>
            <div class="thumbnail">
                <ng-container *ngIf="isVideo(item); else imgTmp">
                    <div [style.width]="'100%'">
                        <app-video-review [width]="'100%'" [borderRadius]="'12px'" [disabled]="true" [height]="'80px'" [videoInfo]="getVideoInfo(item)"></app-video-review>
                    </div>
                </ng-container>

                <ng-template #imgTmp>
                    <img [src]="url(item)" style="display: block;" loading="lazy"/>
                </ng-template>

            </div>
        </ng-template>
    </p-galleria>
</div>
